"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_1 = require("../../model");
const ArtilleryIcon_1 = __importDefault(require("../../icons/ArtilleryIcon"));
const BombIcon_1 = __importDefault(require("../../icons/BombIcon"));
const FireIcon_1 = __importDefault(require("../../icons/FireIcon"));
function hitIcon(hit) {
    switch (hit.type) {
        case model_1.HitType.Artillery:
            return ArtilleryIcon_1.default;
        case model_1.HitType.Fougasse:
            return BombIcon_1.default;
        case model_1.HitType.Incendiary:
            return FireIcon_1.default;
    }
}
exports.default = hitIcon;
